<template>
  <div>
    <v-slider
      v-model="researchItem.answer.value"
      :dot-options="dotOptions"
      :max="researchItem.item.config.max"
      :disabled="asAnswer"
    />
    <div class="d-flex justify-content-between">
      <span>
        {{ researchItem.item.config.min_text }}
      </span>
      <span>
        {{ researchItem.item.config.max_text }}
      </span>
    </div>

    <v-numeric-average
      v-if="showAverage"
      :value="researchItem.answer.value"
      :average="researchItem.average"
    />
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import NumericAverage from '@/reviewer/components/items/snippets/NumericAverage.vue';
import { GenericItemMixin } from '@/reviewer/mixins';


export default {
  name: 'ItemStars',
  mixins: [
    GenericItemMixin,
  ],
  props: {
    showAverage: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    'v-slider': VueSlider,
    'v-numeric-average': NumericAverage,
  },
  computed: {
    dotOptions() {
      return [
        { min: 0, max: this.researchItem.item.config.max },
      ];
    },
  },
};
</script>
